<template>
    <div class="p-grid">
		<div class="p-col-12">
            <TabMenu :model="items" />
            <router-view />
		</div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            items: [
                { label: '全部待审核', icon: 'fa fa-fw fa-info-circle', to: '/approval/toapproveall', visible: () => this.canApprove },
                { label: '待预审核', icon: 'fa fa-fw fa-circle', to: '/approval/toapprovepreapprove', visible: () => this.isPreapprover },
                { label: '待审核', icon: 'fa fa-fw fa-book', to: '/approval/toapproveapprove', visible: () => this.isApprover },
                { label: '已审核', icon: 'fa fa-fw fa-check-square-o', to: '/approval/approved', visible: () => this.canApprove },
                
            ]
        }
    },
    created() {
        
    },
    computed: {
		loggedIn() {
            return this.$store.state.authentication.status.loggedIn;
        },
        userInfo() {
            return this.$store.state.authentication.user;
		},
		canApprove() {
            return this.isPreapprover || this.isApprover;
        },
        isPreapprover() {
			return this.$store.state.authentication.permissions.preapprover === true;
        },
        isApprover() {
			return this.$store.state.authentication.permissions.approver === true;
		},
    }
}
</script>

<style scoped>

</style>